import { render, staticRenderFns } from "./FileReferencePickerElement.vue?vue&type=template&id=087c9640&scoped=true&"
import script from "./FileReferencePickerElement.vue?vue&type=script&lang=js&"
export * from "./FileReferencePickerElement.vue?vue&type=script&lang=js&"
import style0 from "./FileReferencePickerElement.vue?vue&type=style&index=0&id=087c9640&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c9640",
  null
  
)

export default component.exports